"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const webjs_sdk_1 = require("@aria/webjs-sdk");
const bew_localization_1 = require("@skype/bew-localization");
const react_1 = require("@stardust-ui/react");
const config_1 = require("config");
const lodash_1 = require("lodash");
const React = require("react");
const AriaContext_1 = require("src/ts/contexts/AriaContext");
const EnvironmentHelper_1 = require("src/ts/helpers/EnvironmentHelper");
const ErrorHelper_1 = require("src/ts/helpers/ErrorHelper");
const UrlHelper_1 = require("src/ts/helpers/UrlHelper");
const BotsRestClient_1 = require("src/ts/rest/BotsRestClient");
const BotsContext_1 = require("../../contexts/bots/BotsContext");
const LoggerHelper_1 = require("../../helpers/LoggerHelper");
const Footer_1 = require("../common/Footer");
const Padder_1 = require("../common/Padder");
const BotInfo_1 = require("./BotInfo");
const BotLauncher_1 = require("./BotLauncher");
class AddBotView extends React.PureComponent {
    constructor() {
        super(...arguments);
        this._downloadSkype = () => {
            LoggerHelper_1.logger.action({ name: 'download' });
            const downloadUrl = EnvironmentHelper_1.os === EnvironmentHelper_1.OperatingSystems.MacOS ? config_1.default.urls.app.downloadDesktop : config_1.default.urls.app.download;
            window.open(downloadUrl, '_blank');
        };
    }
    render() {
        return React.createElement("div", { className: 'bots addBotView' },
            React.createElement(Padder_1.Padder, null),
            React.createElement("div", { className: 'scrollable-y' },
                React.createElement("div", { className: 'body' },
                    React.createElement(react_1.Header, { as: 'h1', content: 'Skype' }),
                    React.createElement(BotInfo_1.BotInfo, null),
                    React.createElement(BotsContext_1.BotsContextConsumer, null, (botsContext) => botsContext &&
                        (botsContext.isAddedAsContact ? this._renderBotAddedContent(botsContext) : this._renderBotAddPromptContent(botsContext))))),
            React.createElement(Padder_1.Padder, null),
            React.createElement(Footer_1.Footer, { showOnlyLegalInfo: true }));
    }
    _renderBotAddPromptContent(botContext) {
        return React.createElement(React.Fragment, null,
            botContext.botInfo.addAsContactAllowed && this._renderAddButton(botContext),
            this._renderBotDetails(botContext));
    }
    _renderBotAddedContent(botContext) {
        return React.createElement(AriaContext_1.AriaContextConsumer, null, (ariaContext) => React.createElement("div", { ref: () => ariaContext.announce({ assertive: true, text: bew_localization_1.localizer.getString('bot_added') }) },
            React.createElement(react_1.Button, { key: 1, id: 'btnDownload', primary: true, onClick: this._downloadSkype }, bew_localization_1.localizer.getString('download_skype')),
            React.createElement(react_1.Text, { size: 'large', content: bew_localization_1.localizer.getString('bot_added') }),
            React.createElement(BotLauncher_1.BotLauncher, { botSkypeId: botContext.botInfo.skypeId })));
    }
    _renderAddButton(botContext) {
        return React.createElement(react_1.Button, { key: 0, id: 'btnAddBot', primary: true, autoFocus: true, onClick: this._addBotToContacts(botContext) },
            React.createElement(react_1.Text, null, bew_localization_1.localizer.getString('add_to_contacts')));
    }
    _renderBotDetails(botContext) {
        const privacyAndTos = botContext.botInfo.privacyStatement && botContext.botInfo.tos ?
            bew_localization_1.localizer.get('privacy_and_terms', {
                linkPrivacy: { type: 'a', href: botContext.botInfo.privacyStatement },
                linkTerms: { type: 'a', href: botContext.botInfo.tos },
            }) : undefined;
        return React.createElement("section", { className: 'botDetails' },
            React.createElement(react_1.Text, { size: 'medium', content: botContext.botInfo.description }),
            this._renderCapabilities(botContext.botInfo.capabilities),
            React.createElement(react_1.Text, { className: 'disclaimer', size: 'medium', content: bew_localization_1.localizer.getString('bot_disclaimer') }),
            React.createElement("div", { className: 'privacy' }, privacyAndTos));
    }
    _renderCapabilities(botCapabilities) {
        const capabilitiestoLocStringMap = {
            'im.sendReceive': 'capability_im_send_receive',
            'im.send': 'capability_im_send_receive',
            'im.receive': 'capability_im_send_receive',
            'audio.send': 'capability_audio_send',
        };
        const uniqueLocalizedCapabilities = lodash_1.uniq(botCapabilities
            .filter((cap) => !!capabilitiestoLocStringMap[cap])
            .map((cap) => bew_localization_1.localizer.getString(capabilitiestoLocStringMap[cap])));
        return React.createElement("div", { className: 'capabilities' },
            React.createElement(react_1.Header, { as: 'h3', content: bew_localization_1.localizer.getString('capabilities') }),
            React.createElement("ul", null, uniqueLocalizedCapabilities.map((cap, index) => React.createElement("li", { key: index },
                React.createElement(react_1.Text, { size: 'medium', content: cap })))));
    }
    _addBotToContacts(botContext) {
        return () => {
            LoggerHelper_1.logger.action({ name: 'bot-add-contact' }, webjs_sdk_1.AWTEventPriority.Immediate_sync);
            const { skypetoken } = this.props;
            if (!skypetoken) {
                this._redirectToLogin(botContext.botId);
                return;
            }
            this.props.onProgress();
            BotsRestClient_1.default.addBotToContacts(botContext.botId, skypetoken)
                .then(() => this.props.onAdd())
                .catch((response) => {
                const error = response && response.statusCode === 412 ?
                    ErrorHelper_1.ErrorHelper.enrichErrorFromWebResponse(ErrorHelper_1.displayableErrors.BotTooManyContacts, response, 'Add bot request') :
                    ErrorHelper_1.ErrorHelper.enrichErrorFromWebResponse(ErrorHelper_1.displayableErrors.Generic, response, 'Add bot request');
                this.props.onError(error);
            });
        };
    }
    _redirectToLogin(botId) {
        const useBotsLauncherQueryParam = !!UrlHelper_1.UrlHelper.getQueryParameter('botsLauncher');
        window.location.href = config_1.default.urls.app.botLogin(botId, useBotsLauncherQueryParam);
    }
}
exports.AddBotView = AddBotView;
